<template>
  <header class="header">
    <!-- Contêiner para Logotipo Centralizado -->
    <div class="header-container">
      <div class="logo-container">
        <img
          src="../assets/imag tec/logoatt.png"
          alt="Logo da Construtora Vieira"
          class="logo1"
        />
      </div>
      <div class="logo-text">
        <h3 class="main-title">Apollotech</h3>
        <h5 class="subtitle">CRIAÇÃO E INOVAÇÃO</h5>
      </div>
    </div>

    <!-- Menu de navegação -->
    <nav class="nav-menu">
      <ul class="nav-links" :class="{ show: isMenuOpen }">
        <li><router-link to="/" class="menu-item">Início</router-link></li>
        <li><router-link to="/about" class="menu-item">Sobre</router-link></li>
        <li><router-link to="/contact" class="menu-item">Contato</router-link></li>
      </ul>
      <!-- Botão Hambúrguer (para telas menores) -->
      <button class="hamburger" @click="toggleMenu" aria-label="Abrir menu">
        &#9776;
      </button>
    </nav>
  </header>
</template>

<script>
export default {
  name: "MainHeader",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;

      if (this.isMenuOpen) {
        setTimeout(() => {
          this.isMenuOpen = false;
        }, 2000);
      }
    },
  },
};
</script>

<style scoped>
  
  @import url('https://url-da-fonte-29lt.com/fontkit.css');

  * {
    font-family: '29LT Zeyn', sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
 
  .header-container {
    display: flex;
    align-items: center; /* Centraliza verticalmente */
    justify-content: center; /* Centraliza horizontalmente */
    gap: 5px; /* Espaçamento entre a imagem e o texto */
    padding: 5px; /* Espaçamento interno opcional */
    
  }

  .logo-image {
    width: 300px; /* Ajuste o tamanho da imagem conforme necessário */
    height: auto; /* Mantém a proporção da imagem */
  }
 
  .header {

background-color: transparent !important;    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    position: relative;
  }

  /* Centralizar Logotipos */
  .header-content-center {
    background-color: transparent !important;
    display: flex;
    flex: 1; /* Ocupa o espaço central */
  }

  .logo1 {
    width: 60px;
    height: 60px;
    object-fit: cover;
  }
  .logo2 {
    width: 60px;
    height: 60px;
    object-fit: cover;
  }
  .logo { 

     text-align: center;
    color: hsl(0, 0%, 100%); /* Cor principal do texto */
    text-shadow: 
      1px 1px 2px #f0e6b3, /* Sombra dourada */
      -1px -1px 2px #f0e6b3,
      1px -1px 2px #030303,
      -1px 1px 2px #080808;
    width: auto;
    height: auto;
    object-fit: cover;
    padding-top: 1px;
    padding-bottom: 1px;
  }

  /* Menu de navegação */
  .nav-menu {
    background-color: transparent !important;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .nav-links {
    display: flex;
    list-style: none;
    gap: 20px;
    color: aliceblue;
  }

  .menu-item {
    text-decoration: none;
    color: rgb(255, 254, 254);
    font-weight: bold;
    transition: color 0.3s;
  }

  .menu-item:hover {
    color: lab(99.73% 0.33 0.11);
  }

  /* Botão Hambúrguer para telas pequenas */
  .hamburger {
    display: none;
background-color: transparent !important;
    border: none;
    font-size: 30px;
    color: #fff9f9;
    cursor: pointer;
  }
  .logo-text .main-title {
    font-family: '29LT Zeyn';
     font-size: 1,2em;
  font-weight: 200;
  color: #fffdfd; /* Cor dourada */
  text-shadow: 
        1px 1px 1px #fdfdfd;
  letter-spacing: 1px; /* Espaçamento entre as letras */
  text-align: center;
}

.logo-text .subtitle {
  font-family: '29LT Zeyn', sans-serif;
  font-size: 0,5rem;
  font-weight: 50;
  color: #fffcfc; /* Cor cinza */
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0,4px;
}
  @media (max-width: 768px) {
    .nav-links {
      flex-direction: column;
      position: fixed;
      top: 0;
      right: 0;
background-color: transparent !important;
      color: #fefffa;
      text-align: center;
      width: 100%;
      height: 55vw;
      padding-top: 70px;
      transform: translateX(100%);
      z-index: 100;
      transition: transform 0.3s ease-in-out;
    }

    .nav-links.show {
      transform: translateX(0);
    }

    .hamburger {
      background-color: transparent !important;
      display: block;
      position: absolute;
      top: 35px;
      right: 20px;
    }

    .menu-item {
      padding: 15px 0;
      text-align: center;
    }
  }
 
  </style>
